export default "__VITE_ASSET__D2ii3m8d__"